import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { guestGuard } from './core/auth/guest.guard';
import { adminGuard } from './core/auth/admin.guard';
import { toolGuard } from './core/auth/tool.guard';

export const routes: Routes = [
  {
    path: 'login',
    canMatch: [guestGuard],
    loadComponent: () =>
      import('./features/auth/pages/login/login.page').then(
        (component) => component.LoginPage,
      ),
  },
  {
    path: 'forgot-password',
    canMatch: [guestGuard],
    loadComponent: () =>
      import('./features/auth/pages/forgot-password/forgot-password.page').then(
        (component) => component.ForgotPasswordPage,
      ),
  },
  {
    path: 'reset-password/:token',
    canMatch: [guestGuard],
    loadComponent: () =>
      import('./features/auth/pages/reset-password/reset-password.page').then(
        (component) => component.ResetPasswordPage,
      ),
  },
  {
    path: 'support',
    loadComponent: () =>
      import('./features/support/pages/support/support.page').then(
        (component) => component.SupportPage,
      ),
  },
  {
    path: '',
    canMatch: [authGuard],
    loadComponent: () =>
      import('./layout/app-shell/app-shell.component').then(
        (component) => component.AppShellComponent,
      ),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/pages/dashboard/dashboard.page').then(
            (component) => component.DashboardPage,
          ),
      },
      {
        path: 'explorer/system',
        canMatch: [adminGuard],
        data: { scope: 'system' },
        loadComponent: () =>
          import('./features/explorer/pages/explorer/explorer.page').then(
            (component) => component.ExplorerPage,
          ),
      },
      {
        path: 'explorer/:scope',
        loadComponent: () =>
          import('./features/explorer/pages/explorer/explorer.page').then(
            (component) => component.ExplorerPage,
          ),
      },
      {
        path: 'chat',
        loadComponent: () =>
          import('./features/chatbot/pages/chat/chat.page').then(
            (component) => component.ChatPage,
          ),
      },
      {
        path: 'audio/recorder',
        canMatch: [toolGuard],
        data: { toolId: 1 },
        loadComponent: () =>
          import('./features/audio/pages/recorder/recorder.page').then(
            (component) => component.RecorderPage,
          ),
      },
      {
        path: 'audio/transcription',
        canMatch: [toolGuard],
        data: { toolId: 2 },
        loadComponent: () =>
          import('./features/audio/pages/transcription/transcription.page').then(
            (component) => component.TranscriptionPage,
          ),
      },
      {
        path: 'pdf',
        canMatch: [toolGuard],
        data: { toolId: 8 },
        loadComponent: () =>
          import('./features/pdf/pages/pdf/pdf.page').then(
            (component) => component.PdfPage,
          ),
      },
      {
        path: 'document-sync',
        canMatch: [toolGuard],
        data: { toolId: 10 },
        loadComponent: () =>
          import('./features/document-sync/pages/document-sync/document-sync.page').then(
            (component) => component.DocumentSyncPage,
          ),
      },
      {
        path: 'invoices',
        canMatch: [toolGuard],
        data: { toolId: 9 },
        loadComponent: () =>
          import('./features/invoices/pages/invoices/invoices.page').then(
            (component) => component.InvoicesPage,
          ),
      },
      {
        path: 'gasel-regularizations',
        canMatch: [toolGuard],
        data: { toolId: 11 },
        loadComponent: () =>
          import('./features/gasel/pages/gasel-regularizations/gasel-regularizations.page').then(
            (component) => component.GaselRegularizationsPage,
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/pages/profile/profile.page').then(
            (component) => component.ProfilePage,
          ),
      },
      {
        path: 'administration/access/documents',
        canMatch: [adminGuard],
        loadComponent: () =>
          import('./features/administration/pages/access-admin/access-admin.page').then(
            (component) => component.AccessAdminPage,
          ),
      },
      {
        path: 'administration/access',
        canMatch: [adminGuard],
        loadComponent: () =>
          import('./features/administration/pages/access-admin/access-admin.page').then(
            (component) => component.AccessAdminPage,
          ),
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/pages/not-found/not-found.page').then(
        (component) => component.NotFoundPage,
      ),
  },
];
